// 添加样式依赖
import './202208.scss';
import '@/common/css/index.scss';
import $ from 'jquery';
import config from '@/common/js/config';

$(function() {
  console.log(config.deviceType());
  if (config.deviceType()) {
    // window.location.href = window.location.origin + '/mobile.html';
    window.location.href = 'https://m.douni.com';
  }
  $('.check').on('click', function() {
    //获取要滚动元素到页面顶部的距离
    const domOffsetTop = $('.detail').offset().top;
    $('body, html').animate({ scrollTop: domOffsetTop }, 1000);
  });
  $('.ios').on('click', function() {
    window.location.href = 'https://apps.apple.com/cn/app/%E6%8A%96%E4%BD%A0/id1559681005';
  });
  $('.and').on('click', function() {
    window.location.href = 'https://download.douni.com/download/douni_Dtap.apk';
  });
  // $('.menu1').on('click', function() {
  //   $('.menu1').addClass('act');
  //   $('.menu2').removeClass('act');
  //   $('.home').show();
  //   $('.jingwang').hide();
  // });
  // $('.menu2').on('click', function() {
  //   $('.menu2').addClass('act');
  //   $('.menu1').removeClass('act');
  //   $('.jingwang').show();
  //   $('.home').hide();
  // });
});
